module.exports = __webpack_public_path__ + "static/media/man-shopping.4c58423d.png";